var headerConfig = {
    height: "52px",
};

export { headerConfig };
